import React from "react";
import { useParams } from "react-router-dom";

import industries from "../data/industries";

import IndustryHeroPremium from "../components/industries/IndustryHeroPremium";
import IndustryChallenges from "../components/industries/IndustryChallenges";
import IndustryServices from "../components/industries/IndustryServices";

import CTASection from "../components/sections/CTASection";

function IndustryDetailPage() {
  const { slug } = useParams();

  const industry = industries.find(
    (item) => item.slug === slug
  );

  if (!industry) {
    return (
      <div
        style={{
          padding: "150px 20px",
          textAlign: "center",
        }}
      >
        <h1>Industry Not Found</h1>
      </div>
    );
  }

  return (
    <>
      <IndustryHeroPremium industry={industry} />

      <IndustryChallenges
        challenges={industry.challenges}
      />

      <IndustryServices
        services={industry.services}
      />

      <CTASection />
    </>
  );
}

export default IndustryDetailPage;